"use client";

// Factory for the browser-side Supabase client (anon / publishable
// key). Used only for `supabase.auth.*` calls during the Google OAuth
// dance — NOT for `.from(<table>)` queries. Any DB access from the
// browser path would go through service_role via a server action; the
// browser client is intentionally never wired to read application
// tables (those grants are revoked anyway — see auth-tenancy §6.1).

import { createBrowserClient } from "@supabase/ssr";
import { env } from "@/shared/config";

export const createSupabaseBrowserClient = () => {
  if (!env.supabaseUrl || !env.supabasePublishableKey) {
    throw new Error(
      "Missing Supabase env: NEXT_PUBLIC_SUPABASE_URL or NEXT_PUBLIC_SUPABASE_ANON_KEY (fallback: NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY)."
    );
  }

  return createBrowserClient(env.supabaseUrl, env.supabasePublishableKey);
};
